import { IconButton } from "@material-ui/core";
import { DeleteForever, ArrowDownward } from "@material-ui/icons";
import * as React from "react";
import Dropzone from "react-dropzone";
import { getFileName, getFileType, getLoggedInCurrentUserDetails } from "../../utils";
import {
  GridItem,
  RecCountryGridITem,
  GridContainer,
} from "../../styles/general";
import { DropzoneContainer, StyledFormLabel } from "../../styles/form";
import { FieldLoader } from "./field-loader.component";
import FileConfirmationDialog from "./file-dialog.component";
import ConfirmDialog from "./confirm-dialog.component";
import { capitalizeString } from "../../utils";

import { withStyles } from "@material-ui/core/styles";

const styles = (theme: any) => ({
  actionButton: {
    height: "0px",
    marginBottom: "10px",
    paddingTop: "0px",
    "&:hover": {
      background: "transparent",
    },
  },
  fileError: {
    color: "#cc0000",
    fontSize: "14px",
    marginLeft: "5px",
  },
});

class AttachmentContainer extends React.Component<any, any> {
  public state: any = {
    attachmentData: [],
    fileData: [],
    selectedId: "",
    openDialog: false,
    openConfirmDialog: false,
    fileNameError: false,
    fileNames: [],
    uploadedFilesError: false,
    uploadedFiles: [],
  };
  private removeFileId: any = null;

  public constructor(props: any) {
    super(props);

    this.renderTableData = this.renderTableData.bind(this);
  }

  public render() {
    const {
      attachmentLoaderVisible,
      disabled,
      label,
      required,
      classes,
    } = this.props;
    const {
      openDialog,
      fileData,
      openConfirmDialog,
      fileNameError,
      fileNames,
      uploadedFilesError,
      uploadedFiles,
    } = this.state;       
    return (
      <GridItem item={true} xs={12} sm={6} md={6} lg={6}>
        <FileConfirmationDialog
          title="File Upload Confirmation"
          open={openDialog}
          close={this.closeFileConfirmationDialog}
          ok={this.uploadFile}
          content={fileData}
        />
        <ConfirmDialog
          open={openConfirmDialog}
          close={this.closeConfirmDialog}
          title="Are you sure, you want to delete this attachment?"
          content=""
          ok={this.removeAttachment}
        />
        <StyledFormLabel>
          {label} {required ? "*" : null}{" "}
          <strong>(Maximum File Size: 25MB)</strong>
        </StyledFormLabel>
        {attachmentLoaderVisible ? <FieldLoader /> : null}
        <DropzoneContainer>
          {" "}
          {/* accept='image/gif, image/jpeg, image/png, application/pdf,application/vnd.ms-excel' */}
          <Dropzone
            onDrop={this.onDrop}
            disabled={disabled || attachmentLoaderVisible}
          >
            {(dropZoneProps: any) => {
              const { getRootProps, getInputProps } = dropZoneProps;
              return (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              );
            }}
          </Dropzone>
        </DropzoneContainer>
        {fileNameError
          ? fileNames.map((value: any, index: any) => {
            return (
              <div key={index} className={classes.fileError}>
                <strong>{`Filename of file ${value} cannot exceeds 100 characters`}</strong>
              </div>
            );
          })
          : null}

        {uploadedFilesError
          ? uploadedFiles.map((value: any, index: any) => {
            return (
              <div key={index} className={classes.fileError}>
                <strong>{`${value} has been already uploaded`}</strong>
              </div>
            );
          })
          : null}

        <div>{this.renderTableData()}</div>
      </GridItem>
    );
  }

  private onDrop = (acceptedFiles: any, rejectedFiles: any) => {
    if (acceptedFiles.length) {
      // const createdBy = this.props.user.title;
      const { fileNames } = this.state;
      const { attachment } = this.props;
      const files = acceptedFiles;
      let isFileNameError = false;
      let isUploadedFileError = false;
      const uploadedFiles: any = [];

      // Validation to check the same file is not uploaded again.
      if (attachment && attachment.length) {
        attachment.forEach((uploadedFile: any) => {
          files.forEach((selectedFile: any) => {
            if (
              selectedFile.name.toLowerCase() ===
              uploadedFile.fileName.toLowerCase()
            ) {
              isUploadedFileError = true;
              uploadedFiles.push(selectedFile.name);
            }
          });
        });

        if (isUploadedFileError) {
          this.setState({
            uploadedFilesError: true,
            uploadedFiles,
          });
          return;
        }
      }

      files.forEach((item: any) => {
        if (item.name.length > 256) {
          fileNames.push(item.name);
          isFileNameError = true;
        }
      });

      if (isFileNameError) {
        this.setState({
          fileNameError: true,
          fileNames,
          openDialog: false,
          fileData: [],
          uploadedFilesError: false,
          uploadedFiles: [],
        });
      } else {
        this.setState({
          openDialog: true,
          fileData: files,
          fileNameError: false,
          fileNames: [],
          uploadedFilesError: false,
          uploadedFiles: [],
        });
      }
    }
  };

  private uploadFile = () => {    
    const { fileData } = this.state;
    const { onSave, uniqueId, attachment, type, currentUser } = this.props;
    let { name, firstName, lastName, emails } = getLoggedInCurrentUserDetails(currentUser);
    name = capitalizeString(name);
    onSave(fileData, name, uniqueId, attachment, type);
    this.setState({
      openDialog: false,
      fileData: [],
    });
  };

  private closeFileConfirmationDialog = () => {
    this.setState({
      openDialog: false,
      fileData: [],
    });
  };

  private closeConfirmDialog = () => {
    this.setState({
      openConfirmDialog: false,
    });
  };

  private openConfirmDialog = (id: any) => {
    this.removeFileId = id;
    this.setState({
      openConfirmDialog: true,
    });
  };

  /**
   * Function removing the selected file/attachment
   */
  private removeAttachment = () => {
    const { remove, attachment, type } = this.props;
    if (this.removeFileId) {
      remove(this.removeFileId, attachment, type);
    }
    this.closeConfirmDialog();
  };

  /**
   * Function setting attachment grid table(with data)
   */
  private renderTableData = () => {
    const {
      // delAttachmentLoaderVisible,
      disabled,
      attachment,
      classes,
    } = this.props;
    // const { attachmentData } = this.state;
    return (
      <>
        <GridContainer container={true} spacing={40}>
          <RecCountryGridITem
            item={true}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            isheader="true"
          >
            Type
          </RecCountryGridITem>
          <RecCountryGridITem
            item={true}
            xs={8}
            sm={8}
            md={8}
            lg={8}
            isheader="true"
          >
            Filename
          </RecCountryGridITem>

          <RecCountryGridITem
            item={true}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            isheader="true"
          />
        </GridContainer>
        <div className="data-container attachment">
          {attachment &&
            attachment.map((item: any, ind: any) => {
              return (
                <GridContainer container={true} spacing={2} key={ind}>
                  <RecCountryGridITem item={true} xs={2} sm={2} md={2} lg={2}>
                    {getFileType(item.fileName)}
                  </RecCountryGridITem>
                  <RecCountryGridITem
                    item={true}
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    title={item.information}
                  >
                    {getFileName(item.fileName)}
                  </RecCountryGridITem>
                  <RecCountryGridITem
                    item={true}
                    xs={2}
                    sm={2}
                    md={2}
                    lg={2}
                    // title={item.information}
                    title=""
                  >
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <IconButton
                        disabled={disabled}
                        className={classes.actionButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={this.openConfirmDialog.bind(this, item.id)}
                        style={{ marginBottom: 0, paddingTop: "10px" }}
                      >
                        <DeleteForever />
                      </IconButton>
                    </div>
                  </RecCountryGridITem>
                  <RecCountryGridITem
                    item={true}
                    xs={2}
                    sm={2}
                    md={2}
                    lg={2}
                    // title={item.information}
                    title=""
                  >
                    <IconButton
                      className={classes.actionButton}
                      key="download"
                      aria-label="Download"
                      color="inherit"
                      onClick={this.downloadFile.bind(this, item.id)}
                      style={{ marginBottom: 0, paddingTop: "10px" }}
                    >
                      {" "}
                      <ArrowDownward />
                    </IconButton>
                  </RecCountryGridITem>
                </GridContainer>
              );
            })}
        </div>
      </>
    );
  };

  private downloadFile = (fileId: any) => {
    const { download } = this.props;
    download(fileId);
  };
}

// export default AttachmentContainer;
export default withStyles(styles)(AttachmentContainer);
